<template>
  <div id="editor-nav">
    <ul>
      <li :class="{ active: activeTab === CODING_TABS.EDITOR}">
        <a id="tab-editor" class="icon" v-on:click="() => setActiveTab(CODING_TABS.EDITOR)">
          <span>{{ $t('menu.editor') }}</span>
        </a>
      </li>
      <li :class="{ active: activeTab === CODING_TABS.TOPLINE}">
        <a id="tab-top-line" class="icon" v-on:click="() => setActiveTab(CODING_TABS.TOPLINE)">
          <span>{{ $t('menu.top_line') }}</span>
        </a>
      </li>
      <li :class="{ active: activeTab === CODING_TABS.SOURCES, disabled: activeOrganization === ''}">
        <v-popover :disabled="activeOrganization !== ''" trigger="hover focus" classes="['test']">
          <a id="tab-sources" class="icon" v-on:click="() => setActiveTab(CODING_TABS.SOURCES)">
            <span>{{ $t('menu.sources') }}</span>
          </a>
          <template slot="popover">
            <span>{{$t('enable_sources')}}</span>
          </template>
        </v-popover>
      </li>
      <li :class="{ active: activeTab === CODING_TABS.OUTLETS}">
        <a id="tab-outlets" class="icon" v-on:click="() => setActiveTab(CODING_TABS.OUTLETS)">
          <span>{{ $t('menu.outlets') }}</span>
        </a>
      </li>
      <li :class="{ active: activeTab === CODING_TABS.HISTORY}">
        <a id="tab-history" class="icon" v-on:click="() => setActiveTab(CODING_TABS.HISTORY)">
          <span>{{ $t('menu.history') }}</span>
        </a>
      </li>
      <li v-tooltip="missingCategoriesMessage">
        <a 
          id="editor-publish" 
          :class="{ 
              icon: true,
              published: isAnalysisPublished,
              'missing-category': missingCategories && !isAnalysisPublished
            }" 
          @click.prevent.stop="$emit('onPublishAnalysisClick')"
        >
          <span v-if="isAnalysisPublished">{{ $t('menu.unpublish') }}</span>
          <span v-else>{{ $t('menu.publish') }}</span> 
  
          <small 
            v-if="totalCategoryMissing" 
            class="missing-warning"
          >
            <i class="fas fa-exclamation-circle"></i>
          </small>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex';
import { CODING_TABS } from '../../config/const';

export default {
  props: {
    activeTab: {
      type: String,
      required: true
    },
    activeOrganization: {
      type: String,
      default: ''
    },
    missingCategories: {
      type: [Object, null],
      required: false,
      default: null,
    }
  },
  data () {
    return {
      CODING_TABS: CODING_TABS,
    };
  },
  computed: {
    ...mapGetters('analysisArticlePublish', [
      'articleIsPublished'
    ]),
    ...mapState('analysisArticle', [
      'analysisArticle'
    ]),
    isAnalysisPublished () {
      return this.analysisArticle.data && this.analysisArticle.data.data.is_published;
    },
    missingCategoriesList () {
      if (!this.missingCategories) return '';
      
      let list = '';
      let articlelist = '';

      if (this.missingCategories.article && this.missingCategories.article.length) {
        this.missingCategories.article.forEach(category => {
          articlelist += `<li>${category.name}</li>`
        });
  
        list += `
          <li class="list-missing-categories">
            <strong>Article</strong>
            <ul>
              ${articlelist}
            </ul>
          <li>
        `
      }

      this.missingCategories.content.forEach(organization => {

        let listOrg = '';

        organization.missingCategories.forEach(category => {
          listOrg += `<li>${category.name}</li>`
        });

        list += `
          <li class="list-missing-categories">
            <strong>${organization.name}</strong>
            <ul>
              ${listOrg}
            </ul>
          <li>
        `
      });

      return list;
    },
    totalCategoryMissing() {
      if (!this.missingCategories) return 0;

      let totalContent = 0;
    
      if (this.missingCategories.content && this.missingCategories.content.length) {
        this.missingCategories.content
          .forEach(item => {
            totalContent += item.missingCategories.length
          });
      }

      return this.missingCategories.article.length + totalContent;
    },
    missingCategoriesMessage () {
      if (!this.totalCategoryMissing) return null;

      let totalContent = 0;
    
      if (this.missingCategories.content && this.missingCategories.content.length) {
        this.missingCategories.content
          .forEach(item => {
            totalContent += item.missingCategories.length
          });
      }

      let title = this.$tc(
        "tag.form.errors.category_missing",
        this.missingCategories,
        { amount: this.missingCategories.article.length + totalContent }
      );

      return `
        ${title}
        <ul>
          ${this.missingCategoriesList}
        </ul>
      `;
    }
  },
  watch: {
    isAnalysisPublished () {
      if (
        this.articleIsPublished === null &&
        this.analysisArticle && this.analysisArticle.data &&
        this.analysisArticle.data.data.is_published
      ) {
        this.setArticleIsPublished(this.analysisArticle.data.data.is_published);
      }
    }
  },
  methods: {
    ...mapActions({
      'setArticleIsPublished': 'analysisArticlePublish/setArticleIsPublished',
    }),
    setActiveTab (tabName) {
      if(tabName === CODING_TABS.SOURCES && this.activeOrganization === '') {
        return;
      }

      this.$emit('setActiveTab', tabName)
    }
  }
}
</script>

<style lang="scss">
  @import "../../styles/components/coding-ui/navigation";

  li.list-missing-categories {
      ul {
        border: 1px silid red;
        margin-left: 20px;
        list-style: inside;
      }
  }
</style>